import { Html } from "@react-three/drei";
import styles from "./Screen.module.css";
import React, { useRef, useEffect } from "react";
import Module from "./Module";
import { useDispatch, useSelector } from "react-redux";
import { gsap } from "gsap";
import modalContent from '../../UI/Modals/ModalContent.json'; // Importer le JSON

export default function Screen() {
  const sectionRef = useRef();
  const dispatch = useDispatch();
  const currentState = useSelector((state) => state.progression.currentState);
  const isInitialMount = useRef(true);

  // Initialisation au premier montage du composant
  useEffect(() => {
    console.log("📺 Screen MONTÉ - Premier rendu avec currentState:", currentState);
    
    // Toujours initialiser l'écran comme caché par défaut au montage
    // Cela évite l'affichage intempestif lors du rechargement de page
    if (sectionRef.current) {
      console.log("📺 Initialisation: Screen caché par défaut");
      gsap.set(sectionRef.current, { 
        autoAlpha: 0, 
        pointerEvents: "none" 
      });
    }
    
    // Marquer que le montage initial est terminé et vérifier si on doit afficher l'écran
    const timer = setTimeout(() => {
      isInitialMount.current = false;
      
      // Après le délai initial, vérifier si on doit afficher l'écran
      // Mais seulement si l'utilisateur a navigué vers ServiceCenter (pas au rechargement initial)
      // On peut détecter le rechargement initial en vérifiant si l'état vient du localStorage
      // Pour l'instant, on ne fait rien et on laisse l'utilisateur cliquer sur le bouton
      console.log("📺 Montage initial terminé");
    }, 100);
    
    return () => clearTimeout(timer);
  }, []); // Seulement au montage

  // Gérer les changements de currentState
  useEffect(() => {
    if (!sectionRef.current) {
      console.log("⚠️ sectionRef.current est null dans le useEffect");
      return;
    }
    
    // Ne pas afficher l'écran pendant le montage initial
    // Cela évite l'affichage intempestif lors du rechargement de page avec currentState persisté
    if (isInitialMount.current) {
      console.log("📺 Screen - Montage initial, skip l'affichage automatique");
      return;
    }
    
    console.log("📺 Screen - Changement de currentState vers:", currentState);
    
    if (currentState === "ServiceCenter") {
      console.log("✅ Animation affichage du screen ServiceCenter");
      gsap.killTweensOf(sectionRef.current);
      gsap.to(sectionRef.current, {
        autoAlpha: 1,
        duration: 0.6,
        ease: "power2.out",
        onStart: () => {
          if (sectionRef.current) {
            sectionRef.current.style.pointerEvents = "auto";
          }
        },
        onComplete: () => {
          console.log("✅ Animation affichage terminée");
        }
      });
    } else {
      console.log("❌ Animation masquage du screen");
      gsap.killTweensOf(sectionRef.current);
      gsap.to(sectionRef.current, {
        autoAlpha: 0,
        duration: 0.6,
        ease: "power2.out",
        onComplete: () => {
          if (sectionRef.current) {
            sectionRef.current.style.pointerEvents = "none";
          }
        },
      });
    }
  }, [currentState]);

  return (
    <Html position={[0, 1.5, -4.5]} transform distanceFactor={2} zIndexRange={[10, 0]}>
      <section className={styles.screen} ref={sectionRef}>
        {Object.keys(modalContent.ServiceCenter).slice(0, 6).map((moduleKey) => (
          <Module
            key={moduleKey}
            module={moduleKey}
            src={modalContent.ServiceCenter[moduleKey].src}
            analytics={modalContent.ServiceCenter[moduleKey].analytics}
            isNew={modalContent.ServiceCenter[moduleKey].isNew}
            dispatch={dispatch}
          />
        ))}
      </section>
    </Html>
  );
}
